/**
 * 设置 storeId
 * @param {Object} route - 当前页面的路由对象
 * @returns {number} - 返回最终的 storeId
 */
export function setStoreIdFromRouteOrLocalStorage(route) {
  let storeId = 0;

  // 1️⃣ 优先从 URL 参数中获取 storeId
  const queryStoreId = parseInt(route.query.id || route.query.storeId) || 0;

  if (queryStoreId > 0) {
    storeId = queryStoreId;

    // ✅ 修正 this.storeId 的错误引用，改为 storeId
    localStorage.setItem("currentStoreId", storeId.toString());
    // 注意：不再设置 lockStoreId，避免浏览其他店铺后锁定
  } else {
    // 2️⃣ 优先使用 userStoreId（用户自己的店铺，不受浏览影响）
    const userStoreId = parseInt(localStorage.getItem('userStoreId')) || 0;
    const defaultStoreId = parseInt(localStorage.getItem('storeId')) || 0;

    // 优先使用 userStoreId，如果没有则使用默认的 storeId
    storeId = userStoreId > 0 ? userStoreId : defaultStoreId;
  }

  return storeId;
}



// WEBPACK FOOTER //
// ./src/utils/store.js